import React from 'react';
import './humanCallSteps.scss';
import ProgressBarStepper from "../../ProgressBarStepper/ProgressBarStepper";
import SelectCall from "./SelectCall/SelectCall";
import CreateScoreCard from "./CreateScoreCard/CreateScoreCard";
import GenerateCallScore from "./GenerateCallScore/GenerateCallScore";
import {useNavigate} from "react-router-dom";
import RevScoreCard from "./ReviewScoreCard/ReviewScoreCard";

const HumanCallSteps = () => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(1);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        if(activeStep === 1){
            navigate('/call-score');
        }else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    return (
    <div className="human-call-steps-container">
      <ProgressBarStepper
          variant="progress"
          totalSteps={5}
          position="static"
          activeStep={activeStep}
          />
      {
        activeStep === 1 && <SelectCall onFileSelect={handleNext} onSampleCallSelect={handleNext} />
      }
      {
          activeStep === 2 && <CreateScoreCard onSelectCriteria={handleNext}/>
      }
      {
          activeStep === 3 && <RevScoreCard onSelectCriteria={handleNext}/>
      }
      {
          activeStep === 4 && <GenerateCallScore />
      }
      <div className={"steps-nav-buttons"}>
          <button className={"grey-button"} onClick={handleBack}>Back</button>
          {/*<button className={"colored-button"} onClick={handleNext}>Next</button>*/}
      </div>
    </div>
  );
};

export default HumanCallSteps;